export enum ButtonType {
  FLAT = 'flat',
  RAISED = 'raised',
  BORDERED = 'bordered',
  MENU = 'menu'
}
